<script setup lang="ts">
import type { ComponentInternalInstance } from "vue";

// submit処理はこのコンポーネントに管理させる
const props = defineProps<{
  submit: (e: Event) => void;
}>();

// 子からこのコンポーネントを参照可能にする
provide("form", getCurrentInstance());

// 子のフォーム関連のコンポーネントを登録する
const inputs: ComponentInternalInstance[] = [];

// 登録処理
function register(input: ComponentInternalInstance) {
  inputs.push(input);
}

// 削除処理
function unregister(input: ComponentInternalInstance) {
  const idx = inputs.findIndex((i) => input.uid === i.uid);
  inputs.splice(idx, 1);
}

// 外部公開する関数を定義
defineExpose({
  register,
  unregister,
});

// エラー確認
function validate() {
  // エラー処理

  // エラー時のデーターを一時保存
  const cache: { el: any; validated: boolean }[] = [];

  // 各コンポーネントのエラー処理を実行
  for (const input of inputs) {
    if (input.exposed?.validate) {
      const validated = input.exposed.validate();
      cache.push({ el: input.refs.el, validated });
    }
  }
  // エラーがあればその要素にフォーカスする
  cache
    .reverse()
    .filter(({ validated }) => !validated)
    .map(({ el, validated }) => {
      if (!validated && el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

  if (cache.find((e) => e.validated == false)) {
    return false;
  } else {
    return true;
  }
}

// エラー確認を入れたsubmit処理
const _submit = (args: Event) => {
  if (validate()) {
    props.submit(args);
  }
};
</script>

<template>
  <form @submit.prevent="_submit">
    <slot />
  </form>
</template>
